module.exports = __webpack_public_path__ + "static/baseball-by-the-numbers-d2a3e500a0adc2a34b6974e39b279596.jpg";